import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as BackButton } from "../img/bacbuttonicon.svg";
import { instance2 } from "../utils/axiosInstance";
import DatePicker from "react-datepicker";
import CalendarIcon from "../img/calendaricon.svg";
import { formatNumber } from "../numberingformat";
import { useMemo } from "react";

function getReferrerPath() {
  try {
    if (!document.referrer) return "";
    const url = new URL(document.referrer);
    return url.pathname || "";
  } catch {
    return "";
  }
}

export default function JadwalCustomer() {
  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, "0");
    const day = String(thedate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // 1) Preferred: you navigated with state: { from: location.pathname }
  const fromState = location.state?.from ?? "";

  // 2) Fallback: parse browser referrer to a pathname
  const fromPath = useMemo(() => {
    if (fromState) return fromState;
    return getReferrerPath();
  }, [fromState]);

  const hideSimpan = fromPath.startsWith("/tabeljadwalcustomer");

  const startDate = queryParams.get("date");

  const [selectedDate, setSelectedDate] = useState(
    startDate ? new Date(startDate) : new Date(),
  );
  const [isOpen, setIsOpen] = useState(false);
  const [dataCustomers, setDataCustomers] = useState([]);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const storedUserId = localStorage.getItem("userAuthentication");
  const storedKitchenId = localStorage.getItem("kitchenId");
  const kitchenIdKoperasi = queryParams.get("kitchenId");
  const [clusterHeaders, setClusterHeaders] = useState([]);
  const storedKitchenName = localStorage.getItem("kitchenname");
  const storedLocationName = localStorage.getItem("locationname");

  const [deliveryOptions, setDeliveryOptions] = useState([]);
  const [loadingDeliveryOptions, setLoadingDeliveryOptions] = useState(true);
const [isMenuSaved, setIsMenuSaved] = useState(false);
const [checkingMenuStatus, setCheckingMenuStatus] = useState(true);

useEffect(() => {
  const checkMenuSavedStatus = async () => {
    try {
      setCheckingMenuStatus(true);
      const response = await instance2.get(
        `/saved_menu_schedule/kitchen/${storedKitchenId || kitchenIdKoperasi}/${localDateString(selectedDate)}`
      );
      console.log("Menu Saved Status Response:", response.data);
      // Check if saved === "y"
      setIsMenuSaved(response.data[0].saved === "Y");
    } catch (err) {
      console.error("Failed to check menu saved status:", err);
      setIsMenuSaved(false);
    } finally {
      setCheckingMenuStatus(false);
    }
  };

  checkMenuSavedStatus();
}, [storedKitchenId, kitchenIdKoperasi, selectedDate]);
  useEffect(() => {
    const fetchDeliveryOptions = async () => {
      try {
        const response = await instance2.get("customers/delivery_master");
        const options = response.data || [];
        setDeliveryOptions(options);

        // Set default delivery ID = 1 if not already set
        if (!formData.delivery) {
          setFormData((prev) => ({
            ...prev,
            delivery: "1", // Default to ID 1
          }));
        }
      } catch (error) {
        console.error("Error fetching delivery options:", error);
      } finally {
        setLoadingDeliveryOptions(false);
      }
    };

    fetchDeliveryOptions();
  }, []);

  // Handle change in delivery option for a specific cluster
  const handleDeliveryChange = (itemId, clusterId, deliveryValue) => {
    setFormData((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [`delivery_${clusterId}`]: deliveryValue,
      },
    }));
  };

  useEffect(() => {
    const fetchClusters = async () => {
      try {
        const res = await instance2.get("/customers/clusters");
        setClusterHeaders(res.data);
      } catch (err) {
        console.error("Failed to fetch clusters", err);
      }
    };

    fetchClusters();
  }, []);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await instance2.get(
          `/customers/kitchen/${storedKitchenId}/${localDateString(selectedDate)}`,
        );

        setDataCustomers(res.data);

// --- inside fetchCustomers useEffect: initialize per-customer keterangan ---
const initialFormData = res.data.reduce((acc, item) => {
  const updatedItem = {};
  for (let i = 1; i <= 10; i++) {
    const qtyKey = `qty_${i}`;
    const deliveryKey = `delivery_${i}`;
    updatedItem[qtyKey] = item[qtyKey] ?? ""; // default if null
    updatedItem[deliveryKey] = item[deliveryKey] ?? ""; // default if null
  }
  // map server 'note' -> per-customer 'keterangan'
  updatedItem.keterangan = item.note ?? "";
  acc[item.id] = updatedItem;
  return acc;
}, {});
setFormData(initialFormData);

setFormData(initialFormData);

        setFormData(initialFormData);
      } catch (err) {
        setError(err.message || "Failed to fetch customers");
      } finally {
        setLoading(false);
      }
    };
    fetchCustomers();
  }, [selectedDate]);

  const handleInputChange = (e, item) => {
    const { value, name } = e.target;
    const updatedItem = { ...formData[item.id], [name]: value };
    setFormData((prev) => ({ ...prev, [item.id]: updatedItem }));
  };

  const getTotalQty = () => {
    const totalQty = dataCustomers.reduce((sum, item) => {
      const values = Object.values(formData[item.id] || {});
      const total = values.reduce(
        (total, value) => total + (parseInt(value, 10) || 0),
        0,
      );
      return sum + total;
    }, 0);
    return totalQty;
  };

  const isFormValid = () => {
    return dataCustomers.length > 0;
  };

// --- handleSubmit: send note as 1D array (one note per customer), not array-of-arrays ---
const handleSubmit = async (e) => {
  e.preventDefault();

  const customer_id = [];
  const qty_sch = [];
  const delivery = [];
  const keterangan = []; // <-- 1D array: one string per customer

  dataCustomers.forEach((item) => {
    const formEntry = formData[item.id] || {};
    customer_id.push(item.id);

    const customerQtys = [];
    for (let i = 1; i <= 7; i++) {
      customerQtys.push(Number(formEntry[`qty_${i}`] || 0));
    }

    const customerDelivery = [];
    for (let i = 1; i <= 7; i++) {
      customerDelivery.push(Number(formEntry[`delivery_${i}`] || 0));
    }

    // push single per-customer note (not repeated)
    keterangan.push(formEntry.keterangan ?? "");

    qty_sch.push(customerQtys);
    delivery.push(customerDelivery);
  });

  const qty_sch_total = qty_sch
    .flat()
    .reduce((sum, val) => sum + (isNaN(val) ? 0 : val), 0);

  const payload = {
    kitchen_id: parseInt(storedKitchenId),
    date: localDateString(selectedDate),
    qty_sch_total,
    admin_id: storedUserId,
    customer_id,
    qty_sch,
    delivery,
    note: keterangan, // <-- now a 1D array: [note_for_customer1, note_for_customer2, ...]
  };

  console.log("Payload to submit:", payload);

  try {
    const response = await instance2.post(`/kitchen_schedule`, payload);
    console.log("Responsekitchenschedule:", response);
    navigate(
      `/menumingguan?kitchen_id=${parseInt(storedKitchenId)}&startDate=${localDateString(selectedDate)}&endDate=${localDateString(selectedDate)}`,
    );
  } catch (error) {
    console.error("Error:", error);
    setError("Failed to save data");
  }
};



  const CustomInput = React.forwardRef(({ value, onClick, isOpen }, ref) => (
    <button
      className={`flex items-center justify-between w-full px-4 py-3 border rounded-full ${startDate ? "bg-gray-200 cursor-not-allowed" : "bg-white"}`}
      onClick={onClick}
      ref={ref}
      type="button"
    >
      <div className="flex items-center gap-2">
        <img
          src={CalendarIcon}
          alt="Calendar"
          className="h-5 w-5 text-gray-500"
        />
        <span>
          {new Date(value).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          })}
        </span>
      </div>
      <div
        className={`text-black font-semibold transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
      >
        ▼
      </div>
    </button>
  ));

  const getClusterFields = (item) => {
    if (!item || !clusterHeaders) return [];

    // Step 1: filter clusterHeaders by type_id and school_level
    const filteredClusters = clusterHeaders.filter((cluster) => {
      const groupMatch = cluster.group_id === item.type_id;
      const levelMatch =
        item.type_id === 1 ? cluster.level_id === item.school_level : true;
      return groupMatch && levelMatch;
    });

    const clusterFields = [];

    for (let i = 1; i <= 10; i++) {
      const nameKey = `cluster_name_${i}`;
      const qtyKey = `qty_${i}`;
      const deliveryKey = `delivery_${i}`;
      const clusterName = item[nameKey];

      if (!clusterName) continue;

      // Step 2: Temukan cluster hanya di filteredClusters (strict)
      const matchedCluster = filteredClusters.find(
        (c) => c.name?.toLowerCase() === clusterName.toLowerCase(),
      );

      if (matchedCluster) {
        clusterFields.push({
          id: matchedCluster.id,
          name: matchedCluster.name,
          qtyKey,
          qtyValue: item[qtyKey] ?? "",
          deliveryKey,
          deliveryValue: item[deliveryKey] ?? "",
        });
      }
    }

    return clusterFields;
  };

  const maxClusterCount = Math.max(
    0,
    ...dataCustomers.map((item) => getClusterFields(item).length),
  );
  
const grandTotal = dataCustomers.reduce((sum, item) => {
  const clusters = getClusterFields(item);
  const subtotal = clusters.reduce((subSum, cluster) => {
    const val = parseInt(formData[item.id]?.[cluster.qtyKey], 10);
    return subSum + (isNaN(val) ? 0 : val);
  }, 0);
  return sum + subtotal;
}, 0);

  return (
    <div className="p-4">
      <div className="flex items-center gap-4 mb-4">
        <div
          className="bg-white p-2 rounded-full cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <BackButton className="rotate-180 text-black" />
        </div>
        <h1 className="text-xl sm:text-2xl font-medium">
          {startDate ? "Rencana Produksi" : "Input Rencana Produksi"}
        </h1>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="space-y-6">
          <div className="flex flex-col lg:flex-row justify-between gap-6">
            <div className="w-full space-y-4">
              <div className="flex items-center gap-4">
                <label className="w-1/4 md:w-1/12 text-sm text-gray-700">Tanggal</label>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  customInput={
                    <CustomInput value={selectedDate} isOpen={isOpen} />
                  }
                  onCalendarOpen={() => setIsOpen(true)}
                  onCalendarClose={() => setIsOpen(false)}
                  filterDate={(date) =>
                    date.getDay() !== 0 && date.getDay() !== 6
                  }
                  disabled={!!startDate}
                />
              </div>
              <div className="flex items-center gap-4">
                <label className="w-1/4 md:w-1/12 text-sm text-gray-700">
                  Nama Dapur
                </label>
                <input
                  className="w-full px-3 border-none border-gray-300 rounded-lg text-xs py-2 bg-transparent"
                  value={storedKitchenName}
                  disabled
                />
              </div>
              <div className="flex items-center gap-4">
                <label className="w-1/4 md:w-1/12 text-sm text-gray-700">Koperasi</label>
                <input
                  className="w-full px-3 border-none border-gray-300 rounded-lg text-xs py-2 bg-transparent"
                  value={storedLocationName}
                  disabled
                />
              </div>
              <div className="flex items-center gap-4">
                <label className="w-1/4 md:w-1/12 text-sm text-gray-700">Total Porsi</label>
                <input
                  className="w-full px-3 border-none border-gray-300 rounded-lg text-xs py-2 bg-transparent"
                  value={formatNumber(grandTotal)}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="overflow-auto">
           {/* TAMPILAN TABLE UNTUK DESKTOP */}
<table className="w-full table-auto border text-sm hidden sm:table">
  <thead className="bg-white">
    <tr>
      <th className="text-left px-4 py-2">Instansi</th>
      {[...Array(maxClusterCount)].map((_, idx) => (
        <th key={`cluster-${idx}`} className="text-center px-4 py-2"></th>
      ))}
      <th className="text-center px-4 py-2">Total</th>
      <th className="text-center px-4 py-2">Keterangan</th>
    </tr>
  </thead>
  <tbody>
    {dataCustomers.map((item) => {
      const clusters = getClusterFields(item);
      const paddingCount = maxClusterCount - clusters.length;

      return (
        <tr key={item.id} className="border-t">
          <td className="px-4 py-2">{item.name}</td>

          {clusters.map((cluster) => (
            <td key={cluster.id} className="px-4 py-2 text-right align-top">
              <div className="flex flex-col items-center">
                <label className="text-sm mb-2 text-center">{cluster.name}</label>
                <div className="flex items-center justify-center gap-2 w-full">
                  <input
                    type="text"
                    name={cluster.qtyKey}
                    value={formatNumber(formData[item.id]?.[cluster.qtyKey] ?? "")}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^\d]/g, "");
                      handleInputChange(
                        {
                          target: {
                            name: cluster.qtyKey,
                            value: numericValue,
                          },
                        },
                        item
                      );
                    }}
                    className="w-20 border px-3 py-2 rounded-md text-sm text-right"
                  />
                  <select
                    name={`delivery_${item.id}_${cluster.id}`}
                    value={formData[item.id]?.[`delivery_${cluster.id}`] ?? ""}
                    onChange={(e) =>
                      handleDeliveryChange(item.id, cluster.id, parseInt(e.target.value))
                    }
                    className="w-24 border px-2 py-2 rounded-md text-sm"
                  >
                    <option value="" disabled>Pilih</option>
                    {deliveryOptions.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </td>
          ))}

          {[...Array(paddingCount)].map((_, idx) => (
            <td key={`pad-${idx}`} className="px-4 py-2"></td>
          ))}

          <td className="px-4 py-2 text-right font-semibold">
            {formatNumber(
              clusters.reduce((sum, cluster) => {
                const val = parseInt(formData[item.id]?.[cluster.qtyKey], 10);
                return sum + (isNaN(val) ? 0 : val);
              }, 0)
            )}
          </td>

<td className="px-4 py-2">
  <input
    type="text"
    name="keterangan"
    value={formData[item.id]?.keterangan ?? ""}
    onChange={(e) =>
      handleInputChange(
        { target: { name: "keterangan", value: e.target.value } },
        item
      )
    }
    placeholder="Keterangan..."
    className="w-full border px-3 py-2 rounded-md text-sm"
  />
</td>

        </tr>
      );
    })}
  </tbody>
   <tfoot>
    <tr className="border-t bg-gray-100">
      <td className="px-4 py-2 font-bold text-right" colSpan={maxClusterCount + 1}>
        Total Porsi
      </td>
      <td className="px-4 py-2 text-right font-bold">
       {formatNumber(grandTotal)}
      </td>
    </tr>
  </tfoot>
</table>

{/* TAMPILAN CARD UNTUK MOBILE */}
<div className="sm:hidden flex flex-col gap-4 mt-4">
  {dataCustomers.map((item) => {
    const clusters = getClusterFields(item);
    const total = clusters.reduce((sum, cluster) => {
      const val = parseInt(formData[item.id]?.[cluster.qtyKey], 10);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);

    return (
      <div key={item.id} className="border rounded-lg shadow p-4 bg-white">
        <h3 className="font-semibold mb-2 text-sm">{item.name}</h3>

        {clusters.map((cluster) => (
          <div key={cluster.id} className="mb-2">
            <div className="text-xs text-gray-700 mb-1">{cluster.name}</div>
            <div className="flex items-center gap-2">
              <input
                type="text"
                name={cluster.qtyKey}
                value={formatNumber(formData[item.id]?.[cluster.qtyKey] ?? "")}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^\d]/g, "");
                  handleInputChange(
                    {
                      target: {
                        name: cluster.qtyKey,
                        value: numericValue,
                      },
                    },
                    item
                  );
                }}
                className="w-1/2 border px-3 py-2 rounded-md text-xs text-right"
              />
              <select
                name={`delivery_${item.id}_${cluster.id}`}
                value={formData[item.id]?.[`delivery_${cluster.id}`] ?? ""}
                onChange={(e) =>
                  handleDeliveryChange(item.id, cluster.id, parseInt(e.target.value))
                }
                className="w-1/2 border px-2 py-2 rounded-md text-xs"
              >
                <option value="" disabled>Pilih</option>
                {deliveryOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ))}
<div className="mt-3">
  <input
    type="text"
    name="keterangan"
    value={formData[item.id]?.keterangan ?? ""}
    onChange={(e) =>
      handleInputChange(
        { target: { name: "keterangan", value: e.target.value } },
        item
      )
    }
    placeholder="Keterangan..."
    className="w-full border px-3 py-2 rounded-md text-sm"
  />
</div>
        <div className="mt-3 text-sm font-semibold text-right">
          Total: {formatNumber(total)}
        </div>
      </div>
    );
  })}
  {/* TOTAL KESELURUHAN - UNTUK MOBILE */}
<div className="sm:hidden flex justify-end mt-4">
  <div className="text-sm font-semibold">
    Total Porsi: {formatNumber(grandTotal)}
  </div>
</div>
</div>

          </div>

          <div className="flex justify-center mt-6 gap-5">
            <button
              className="bg-merah-no text-white py-3 px-6 rounded-lg hover:bg-merah-hover"
              onClick={() => navigate(-1)}
            >
              Kembali
            </button>
      {!isMenuSaved && (
        <button
          onClick={handleSubmit}
          disabled={!isFormValid()}
          className={`py-3 px-6 rounded-lg text-sm ${
            isFormValid()
              ? "bg-merah-no text-white hover:bg-merah-hover"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Simpan
        </button>
      )}
          </div>
        </div>
      )}
    </div>
  );
}
